var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"content",class:['splitter','reveal',_vm.isFadeOut ? 'fadeout': '']})}
var staticRenderFns = []

export { render, staticRenderFns }